import { API } from 'app/utils/client';
import { IUser } from 'app/models';
import { CRUDService } from './api';

export class UserService extends CRUDService<IUser> { }

const instance = new UserService(API, 'v1/users');
export default instance;
